import { api } from '@/src/shared/lib/api'

export async function userBlacklistGet<ApiResponse>(pageView?: string) {
  const url = api.appURL('user/blacklist')
  if (pageView) url.searchParams.set('page_view', pageView)
  const response = await api.get<ApiResponse>(url, {})
  return api.parseRespone<ApiResponse>(response)
}
